import {Directive, HostListener, Input} from '@angular/core'

@Directive({
  selector: '[appAutoTab]'
})
export class AutoTabDirective {
  @Input('appAutoTab') appAutoTab: any;

  @HostListener('input', ['$event.target']) onInput(input: HTMLInputElement) {
    const length = input.value.length;
    //const maxLength = input.attributes.length;
    if (length == 1) {
      this.appAutoTab.focus();
    }
  }
}